import { KYMW1501Component } from './kymw1501.component';
import { GetMarkFileRequestModel } from './vo/get-mark-file-request.model';

/**
 * マーク検索条件設定画面の値を管理するクラス
 *
 * @export KYMW1501Model
 * @class KYMW1501Model
 */
export class KYMW1501Model {

  kymw1501Component: KYMW1501Component;

  /** 渡された時点のVO  */
  kymw1501InputVO = new GetMarkFileRequestModel();

  /** マーク名 */
  public markName: string = <string>'';

  /** マークファイル名 */
  public markFileName: string = <string>'';

  /** マークグループコード */
  public markGroupCode: string = <string>'';

  /** 供給促進マーク区分 */
  public supplyPromoteMarkDiv: string = <string>'';

  /** マーク名登録日・開始   */
  //  public registMarkDateFrom: Date = null;
  public registMarkDateFrom: string = <string>'';

  /** マーク名登録日・終了 */
  public registMarkDateTo: string = <string>'';

  /** マークファイル登録日・開始   */
  public fileRegistDateFrom: string = <string>'';

  /** マークファイル登録日・終了   */
  public fileRegistDateTo: string = <string>'';

  /** マークファイル未登録のみ */
  public fileNonRegistOnly: boolean;

  /** 使用停止マークのみ */
  public unableOnly: boolean;

}
